import React from 'react'
import useCrashStore from '../store/useCrashStore'
import { hundredsToX } from '../utils/crashHelpers'

/**
 * Лента последних точек краха сверху экрана (§9).
 * Источник — crash:history (сокет, до 20 значений, свежие первыми).
 * REST НЕ нужен — лента мгновенная, обнуляется при перезапуске процесса бэкенда.
 *
 * Цвет по порогу: ниже 2.00× — красный, иначе зелёный.
 */
const CrashHistoryStrip = () => {
  const history = useCrashStore((s) => s.history)

  if (!history || history.length === 0) {
    return (
      <div className="flex items-center justify-center h-10 text-text-secondary text-xs">
        {/* Пустая лента — до первого раунда */}
      </div>
    )
  }

  return (
    <div
      className="
        flex items-center gap-1.5 overflow-x-auto py-2
        [mask-image:linear-gradient(to_right,black,black_calc(100%_-_20px),transparent)]
      "
    >
      {history.map((point, i) => {
        const isLow = Number(point) < 200
        return (
          <div
            key={`${i}-${point}`}
            className={`
              shrink-0 px-2.5 py-1 rounded-lg text-xs font-bold tabular-nums
              ${isLow
                ? 'bg-red-500/15 text-red-400 border border-red-500/30'
                : 'bg-accent-primary/15 text-accent-primary border border-accent-primary/30'}
            `}
          >
            {hundredsToX(point)}×
          </div>
        )
      })}
    </div>
  )
}

export default CrashHistoryStrip
